import { createSelector } from 'reselect';
import { getCurrentCinemas, getWithNewDesign } from 'app/selectors/AppSelectors';
import { IReduxState } from 'app/types/state';
import { CinemaWithDailySeances, IPreparedDailySeance } from 'app/types/common';
import { getCinemasFilterValues } from 'app/modules/filters/redux/selectors';

export const getDailySeances = (state: IReduxState) => state.dailySeancesReducer.dailySeances;
export const getDailyReleases = (state: IReduxState) => state.dailySeancesReducer.dailyReleases;
export const getIsFetching = (state: IReduxState) => state.dailySeancesReducer.isFetching;
export const getDailySeancesErrorCode = (state: IReduxState) => state.dailySeancesReducer.error.code;

export const getPreparedDailySeances = createSelector(
	[getDailySeances, getDailyReleases],
	(seances, releases): IPreparedDailySeance[] => (
		seances.map(({
			release_id,
			...seanceData
		}) => {
			const {
				age_rating,
				title,
				genres,
				rambler_id,
			} = _.findWhere(releases, { id: release_id }) || {
				age_rating: '',
				title: '',
				genres: [],
				rambler_id: null,
			};

			return {
				...seanceData,
				release_id,
				age_rating,
				title,
				genres,
				rambler_id,
			};
		})
	),
);

export const getSeveralCinemasWithDailySeances = createSelector(
	[getPreparedDailySeances, getCurrentCinemas],
	(seances, cinemas): CinemaWithDailySeances[] => {
		const cinemaSeances = cinemas.reduce((memo, cinema) => {
			memo[cinema.id] = [];

			return memo;
		}, {});

		const seancesForCinemas = seances.reduce<{ [key: number]: IPreparedDailySeance[] }>((memo, seance) => {
			if (Object.keys(cinemaSeances).includes(seance.cinema_id.toString())) {
				memo[seance.cinema_id].push(seance);
			}

			return memo;
		}, cinemaSeances);

		return cinemas.map(cinema => ({
			id: cinema.id,
			title: cinema.title,
			address: cinema.address,
			seances: seancesForCinemas[cinema.id],
		}));
	},
);

export const getFilteredSeveralCinemasWithDailySeances = createSelector(
	[
		getSeveralCinemasWithDailySeances,
		getWithNewDesign,
		getCinemasFilterValues,
		(_, filterValue: string) => filterValue,
	],
	(
		cinemasWithSeances,
		withNewDesign,
		cinemasFilterValues,
		filterValue,
	): CinemaWithDailySeances[] => (
		cinemasWithSeances.filter(({id, seances}) => seances.length && (
			withNewDesign
				? !cinemasFilterValues || cinemasFilterValues[id]
				: !filterValue || id === +filterValue
		))
	)
);